// extracted by mini-css-extract-plugin
export default {"posContainer":"styles_posContainer__HGF9+","posItem":"styles_posItem__87TYw"};